import React from 'react';
import './AlreadyAnswred.css';

function AlreadyAnswred () {
    return (
        <div className='page-alreadyAnswred'>
            Você já preencheu esta pesquisa ou o tempo para responder esta expirado.
        </div>
    )
}
export default AlreadyAnswred;